import React from 'react';
import { Divider } from "../Divider";
import { TextButton } from "../TextButton";
import styles from "./MenuContextualAction.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function MenuContextualAction(_ref) {
  let {
    title: text,
    intent,
    testId,
    icon,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Divider, {
      margin: 0
    }), /*#__PURE__*/_jsx(TextButton, {
      underline: "none",
      weight: "normal",
      className: styles.root,
      intent: intent,
      "data-testid": testId,
      prefixIcon: icon,
      onClick: onClick,
      children: text
    })]
  });
}